import {AfterViewInit, Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[appExpandText]',
})
export class ExpandTextDirective implements OnInit, AfterViewInit {
  @Input() expandable: boolean;
  @Input() onlyTruncate: boolean;
  @Input() maxCharacters = 150;
  @Input() expandText = 'Ver más';
  @Input() collapseText = 'Ver menos';
  originalContent = '';
  constructor(private element: ElementRef) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.originalContent = this.element.nativeElement.textContent;

    this.sliceText();

    const node = document.createElement('span');
    node.style.color = '#318399';
    node.style.cursor = 'pointer';
    if (!this.onlyTruncate) {
      node.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.expandable = !this.expandable;
        this.element.nativeElement.textContent = this.originalContent;
        if (!this.expandable) this.sliceText();
        node.style.display = this.expandable ? 'block' : 'inline';
        this.createTextNode(node);
      });
    }
    this.createTextNode(node);
  }

  createTextNode(node): void {
    if (this.originalContent.length > this.maxCharacters) {
      const text = document.createTextNode(
        this.expandable ? ' ' + ('\n' + this.collapseText) : '... ' + this.expandText
      );
      node.innerText = '';
      node.appendChild(text);
      this.element.nativeElement.appendChild(node);
    }
  }

  sliceText(): void {
    this.element.nativeElement.textContent =
      this.element.nativeElement.textContent.slice(0, this.maxCharacters);
  }
}
